import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

const FooterContainer = styled(Box)({
  position: 'sticky',
  zIndex: 1000,
  backgroundColor: '#0047ba',
  boxSizing: 'border-box',
  height: '45px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin:'0 auto',
  color: 'white',
  bottom: 0,
  width: '100%',
});

const Footer: React.FC = () => {
  return (
    <FooterContainer>
    </FooterContainer>
  );
};

export default Footer;